export default options =>
  new Set(
    options.map(
      ({
        price: {
          current: { value }
        }
      }) => value
    )
  ).size > 1;
